module.exports = __webpack_public_path__ + "static/img/magicBayGiftButton.7036880.png";